import { useMemo } from "react";

// Détecte la langue depuis le domaine, le paramètre URL ou localStorage.
// cruiseai.ca (ou redirect via ?lang=en) → en
// croisiereai.ca → fr
export function useLanguage() {
  const lang = useMemo(() => {
    // 1. Paramètre URL ?lang=en (utilisé par le redirect cruiseai.ca → croisiereai.ca?lang=en)
    const urlParam = new URLSearchParams(window.location.search).get("lang");
    if (urlParam === "en" || urlParam === "fr") return urlParam;
    // 2. Hostname : cruiseai.ca → EN
    const host = window.location.hostname;
    if (host.includes("cruiseai") && !host.includes("croisiere")) return "en";
    // 3. Préférence sauvegardée
    const stored = localStorage.getItem("croisiere_lang");
    if (stored === "en" || stored === "fr") return stored;
    return "fr";
  }, []);
  return { lang, isEN: lang === "en", isFR: lang === "fr" };
}
